var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer, useState } from 'react';
import AppLayout from '@/Layouts/AppLayout';
import { Link, usePage } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
import ButtonLink from '@/Jetstream/ButtonLink';
import SuccessModal from '@/Jetstream/SuccessModal';
import Confetti from 'react-confetti';
import { BuildingStorefrontIcon } from "@heroicons/react/24/outline";
import Pagination from "../Jetstream/Pagination";
import { router } from '@inertiajs/react';
import axios from "axios";
import InvitationModal from '@/Jetstream/InvitationModal';
import CreateTeamForm from '@/Pages/Teams/CreateTeamForm';
export default function Dashboard(_a) {
    var _b, _c, _d;
    var team = _a.team, branches = _a.branches, permissions = _a.permissions, invitation = _a.invitation;
    var route = useRoute(Ziggy);
    var flash = usePage().props.flash;
    var _e = useState(true), paymentSuccessOpen = _e[0], setPaymentSuccessOpen = _e[1];
    var _f = useState(true), invitationOpen = _f[0], setInvitationOpen = _f[1];
    var params = new URLSearchParams(window.location.search);
    var _g = useState(params.get('search') ? params.get('search') + "" : ""), search = _g[0], setSearch = _g[1];
    useEffect(function () {
        if (flash.new_credits) {
            setPaymentSuccessOpen(true);
        }
    });
    function doSearch(element) {
        var value = element.value;
        setSearch(value);
        console.log('_.debounce');
        var current = window.location.href.replace(/\?.*/, '');
        params.set('search', value);
        params.set('page', "1");
        router.get(current + '?' + params.toString(), {}, {
            onSuccess: function () {
                document.getElementById('search').focus();
            }
        });
    }
    var _h = useReducer(function (x) { return x + 1; }, 0), ignored = _h[0], forceUpdate = _h[1];
    function toggleBookmark(branch) {
        if (branch.bookmark) {
            axios.post(route('team.branch.bookmark', { team: team, branch: branch }), { bookmark: 0 }).then(function (resp) {
                branch.bookmark = resp.data;
                forceUpdate();
            });
        }
        else {
            axios.post(route('team.branch.bookmark', { team: team, branch: branch }), { bookmark: 1 }).then(function (resp) {
                branch.bookmark = resp.data;
                forceUpdate();
            });
        }
    }
    return (_jsxs(AppLayout, __assign({ title: "Dashboard", pageTitle: team ? team.name : "Your account does not belong to a team" }, { children: [flash.new_credits && paymentSuccessOpen && (_jsxs(_Fragment, { children: [_jsx(Confetti, {}), _jsx(SuccessModal, { open: paymentSuccessOpen, onClose: function () {
                            setPaymentSuccessOpen(false);
                            flash.new_credits = null;
                        }, message: flash.new_credits })] })), invitation && (_jsx(InvitationModal, { invitation: invitation, open: invitationOpen, onClose: function () {
                    setInvitationOpen(false);
                } })), !team && _jsx(CreateTeamForm, {}), team && _jsxs("div", { children: [_jsxs("div", __assign({ className: "py-6 flex items-center justify-between" }, { children: [_jsx("h2", __assign({ className: "text-xl" }, { children: "Branches" })), ((_c = (_b = team.permissions) === null || _b === void 0 ? void 0 : _b.branch) === null || _c === void 0 ? void 0 : _c.create) && _jsx(ButtonLink, __assign({ id: "add_branch", href: route('team.branch.create', { team: team.id }) }, { children: "Add a branch" }))] })), _jsxs("div", __assign({ className: "mt-6 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" }, { children: [branches.data.map(function (branch, idx) {
                                var _a, _b;
                                return _jsxs(Link, __assign({ className: "flex flex-col p-4 text-center rounded-lg border border-sky-500 bg-white hover:bg-sky-100 transition-colors shadow-lg ", href: route('team.branch.certificate.index', { team: team.id, branch: branch.id }) }, { children: [_jsx(BuildingStorefrontIcon, { className: "h-10 w-10 text-black text-opacity-20 mx-auto" }), _jsx("div", __assign({ className: " text-sm font-medium text-gray-900 text-xl my-4 overflow-ellipsis overflow-hidden" }, { children: branch.name })), _jsx("div", __assign({ className: " text-sm text-gray-600 overflow-ellipsis overflow-hidden" }, { children: branch.address_data ? [(_a = branch.address_data) === null || _a === void 0 ? void 0 : _a.line_1, (_b = branch.address_data) === null || _b === void 0 ? void 0 : _b.city].filter(Boolean).join(", ") : '' }))] }), idx);
                            }), ((_d = branches.data) === null || _d === void 0 ? void 0 : _d.length) === 0 && _jsx("div", { children: _jsx("div", __assign({ className: "px-6 py-4 whitespace-nowrap text-sm font-medium text-center" }, { children: _jsx("em", { children: "No branches..." }) })) })] })), branches.last_page > 1 && _jsx(Pagination, { pagination: branches })] })] })));
}
